import * as i0 from '@angular/core';
import { inject, ChangeDetectorRef, Pipe } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DatePipe } from '@angular/common';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
function getIconInfo(icon, fontSet = 'material-symbols-outlined') {
  if (typeof icon === 'string') {
    return {
      icon,
      fontSet
    };
  }
  return {
    icon: icon.icon,
    fontSet: icon.fontSet || fontSet
  };
}
function deepCopy(o) {
  if (o == null) {
    return o;
  }
  return JSON.parse(JSON.stringify(o));
}
function deepCompare(o1, o2) {
  if (o2 == null) {
    if (o1 == null) {
      return o2 === o1;
    }
    return false;
  }
  return JSON.stringify(o1) === JSON.stringify(o2);
}
function getTranslateModel(text) {
  if (!text) {
    return {
      text: ''
    };
  }
  if (typeof text === 'string') {
    return {
      text
    };
  }
  return text;
}
let LocalizeDatePipe = /*#__PURE__*/(() => {
  class LocalizeDatePipe {
    constructor() {
      this.cdr = inject(ChangeDetectorRef);
      this.service = inject(TranslocoLocaleService);
      this.datePipe = inject(DatePipe);
      this.service.localeChanges$.pipe(takeUntilDestroyed()).subscribe(() => this.cdr.markForCheck());
    }
    transform(value, format) {
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return null;
      }
      return this.datePipe.transform(date, format, undefined, this.service.getLocale());
    }
    static {
      this.ɵfac = function LocalizeDatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LocalizeDatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "futLocalizeDate",
        type: LocalizeDatePipe,
        pure: false,
        standalone: true
      });
    }
  }
  return LocalizeDatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { LocalizeDatePipe, deepCompare, deepCopy, getIconInfo, getTranslateModel };
